module.exports = __webpack_public_path__ + "static/media/fb08661d-e0e5-4ff4-938d-3b266d86ac25.79b2bf5d.png";